export const COUPONS_ORIGIN = 'events';
export var COUPONS_SCOPES;
(function (COUPONS_SCOPES) {
    COUPONS_SCOPES["TICKETS"] = "ticket";
    COUPONS_SCOPES["TICKET"] = "ticket";
    COUPONS_SCOPES["EVENT"] = "event";
})(COUPONS_SCOPES || (COUPONS_SCOPES = {}));
export var CouponErrorCode;
(function (CouponErrorCode) {
    CouponErrorCode["ERROR_COUPON_DOES_NOT_EXIST"] = "ERROR_COUPON_DOES_NOT_EXIST";
    CouponErrorCode["ERROR_COUPON_IS_NOT_ACTIVE_YET"] = "ERROR_COUPON_IS_NOT_ACTIVE_YET";
    CouponErrorCode["ERROR_COUPON_HAS_EXPIRED"] = "ERROR_COUPON_HAS_EXPIRED";
    CouponErrorCode["ERROR_COUPON_USAGE_EXCEEDED"] = "ERROR_COUPON_USAGE_EXCEEDED";
    CouponErrorCode["ERROR_COUPON_IS_DISABLED"] = "ERROR_COUPON_IS_DISABLED";
    CouponErrorCode["CUSTOM_ERROR_TOO_BUSY"] = "CUSTOM_ERROR_TOO_BUSY";
    CouponErrorCode["CUSTOM_ERROR_UNKNOWN"] = "CUSTOM_ERROR_UNKNOWN";
    CouponErrorCode["ERROR_INVALID_PRODUCTS"] = "ERROR_INVALID_PRODUCTS";
    CouponErrorCode["ERROR_INVALID_SUBTOTAL"] = "ERROR_INVALID_SUBTOTAL";
    CouponErrorCode["ERROR_INVALID_PRODUCT_QUANTITY"] = "ERROR_INVALID_PRODUCT_QUANTITY";
})(CouponErrorCode || (CouponErrorCode = {}));
//# sourceMappingURL=coupons.js.map